import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';

export interface BirdEyePageEyebrowProps {
  className?: string;
}

export function BirdEyePageEyebrow({ className }: BirdEyePageEyebrowProps) {
  return (
    <div className={cn('cal-fade flex min-w-0 items-center gap-2', className)}>
      <Icon kind="eye" size={13} stroke={2} color="var(--ai-3)" />
      <span className="font-[var(--font-mono)] text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--ai-3)]">
        Floor · live
      </span>
    </div>
  );
}

export interface BirdEyePageTitleBlockProps {
  className?: string;
}

export function BirdEyePageTitleBlock({ className }: BirdEyePageTitleBlockProps) {
  return (
    <div className={cn('cal-fade min-w-0', className)}>
      {/* Fix-list #3: the page name belongs here, not a marketing line, and the
          system has no gradient text — a plain title, brand accent on word two. */}
      <h1 className="m-0 font-[var(--font-display)] text-[clamp(28px,3.6vw,40px)] font-bold leading-none tracking-[-0.04em] text-[var(--text-primary)]">
        Bird Eye <span className="text-[var(--brand-indigo)]">View</span>
      </h1>
    </div>
  );
}
